"use client";

import { ReactNode, useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDownIcon } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Command, CommandGroup, CommandItem } from "@/components/ui/command";
import { CommandList } from "cmdk";
import { createPath } from "@/service/routing/routing";

export const ExamPageTypeTitle = ({
  type,
  title,
  isH1 = false,
  showExamTypeSelector,
}: {
  type?: ExamType;
  title: ReactNode;
  isH1?: boolean;
  showExamTypeSelector?: boolean;
}) => {
  const Heading = ({ children }: { children: ReactNode }) => {
    const headingStyles = "text-2xl font-semibold";
    return isH1 ? (
      <h1 className={headingStyles}>{children}</h1>
    ) : (
      <div className={headingStyles}>{children}</div>
    );
  };

  return (
    <header
      className={`text-foreground mb-6 flex w-full flex-col gap-4 sm:w-auto sm:flex-row sm:items-center`}
    >
      <Heading>{title}</Heading>
      {showExamTypeSelector && (
        <div className={"flex flex-col gap-4 sm:flex-row sm:items-center"}>
          <SelectExamType type={type} />
        </div>
      )}
    </header>
  );
};

const SelectExamType = ({ type }: { type: ExamType }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <Popover open={isOpen} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button variant={"blue"}>
          {type}
          <ChevronDownIcon size={16} className={"stroke-white"} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="popover-content-width-same-as-its-trigger font-inter relative z-1000 bg-white p-0">
        <Command>
          <CommandList>
            <CommandGroup>
              <CommandItem
                className={"text-xs"}
                onSelect={() => {
                  window.location.href = createPath("exam.page_type", {
                    type: "pes",
                  });
                  setOpen(false);
                }}
              >
                PES
              </CommandItem>
              <CommandItem
                className={"text-xs"}
                onSelect={() => {
                  window.location.href = createPath("exam.page_type", {
                    type: "lek",
                  });
                  setOpen(false);
                }}
              >
                LEK
              </CommandItem>
              <CommandItem
                className={"text-xs"}
                onSelect={() => {
                  window.location.href = createPath("exam.page_type", {
                    type: "ldek",
                  });
                  setOpen(false);
                }}
              >
                LDEK
              </CommandItem>
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
